var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearning02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1334 994",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1333.33,993.75l-1333.33,-0l0,-952.083c0,-11.051 4.39,-21.649 12.204,-29.463c7.814,-7.814 18.412,-12.204 29.463,-12.204c198.977,-0 1051.02,-0 1250,-0c11.05,-0 21.648,4.39 29.462,12.204c7.814,7.814 12.204,18.412 12.204,29.463c0,188.469 0,952.083 0,952.083Z",
    style: {
      fill: "#f3cc84",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.538,940.873c-239.217,0 -433.139,-12.602 -433.139,-28.142c-0,-15.545 193.922,-28.147 433.139,-28.147c239.214,0 433.138,12.602 433.138,28.147c0,15.54 -193.924,28.142 -433.138,28.142Z",
    style: {
      fill: "#d6a95b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.676,228.769l0,449.092l-886.595,-0l-0,-449.092c-0,-27.032 22.054,-48.948 49.255,-48.948l788.083,0c27.2,0 49.257,21.916 49.257,48.948Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.419,783.018l-788.083,0c-27.203,0 -49.255,-21.914 -49.255,-48.944l-0,-56.294l886.595,0l0,56.294c0,27.03 -22.052,48.944 -49.257,48.944Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.619,901.185l-348.482,-0c54.181,-0 55.413,-118.086 55.413,-118.086l237.655,-0c-0,-0 10.466,118.086 55.414,118.086Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.137,
    y: 901.185,
    width: 348.482,
    height: 15.905,
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.163,308.323l5.472,82.06l-88.475,5.826l14.818,-107.786l68.185,19.9Z",
    style: {
      fill: "#eac2a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.633,173.285c0,-0 18.148,93.506 -13.943,131.132c-32.095,37.626 -96.662,20.466 -96.662,20.466c-0,-0 -32.689,-7.94 -48.014,-34.685c-13.294,-23.201 -48.828,-33.868 -56.769,-51.769c-24.218,-54.59 8.076,-107.343 8.076,-107.343c0,0 167.741,-49.122 194.079,-8.573c4.719,7.258 13.233,50.772 13.233,50.772Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.897,267.093l9.116,23.107c-0,-0 -62.73,-26.988 -66.756,-87.282c-1.163,-17.538 -7.555,-62.582 10.757,-92.167c25.693,-41.483 100.439,-67.492 166.691,-35.217c94.809,46.192 36.605,62.837 36.605,62.837c-0,-0 -52.537,24.481 -91.342,0.965c-27.728,-16.802 -53.069,10.455 -61.804,37.704l-5.303,37.496l-0.82,5.786l-0.275,1.987c-0,-0 -24.694,-29.949 -39.462,-13.198c-14.757,16.766 -5.471,53.914 37.642,45.439l0.898,2.269l4.053,10.274Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.6,340.696c13.433,-9.946 30.467,-13.486 46.943,-16.494c6.419,-1.172 14.024,-1.951 18.538,2.731c4.157,4.309 3.495,11.599 0.148,16.554c-3.348,4.954 -8.715,8.124 -13.905,11.129c22,-0.169 44.005,0.34 65.976,1.526c6.776,0.366 13.705,0.831 19.952,3.46c6.253,2.628 11.809,7.86 12.962,14.508c1.234,7.119 -2.862,14.333 -8.59,18.782c-5.724,4.449 -12.862,6.647 -19.862,8.581c-20.367,5.626 -41.143,9.788 -62.114,12.441c-15.391,1.948 -31.324,3.041 -46.167,-1.449c-5.295,-1.602 -25.852,36.359 -29.91,33.506c-12.171,-8.56 -48.557,-31.574 -47.481,-44.961c0.862,-10.71 52.372,-52.07 63.51,-60.314Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.157,438.064c-1.243,1.789 -30.895,44.241 -67.643,86.115c-22.357,25.483 -42.876,45.599 -60.985,59.801c-12.381,9.71 -23.724,16.794 -34.667,21.659c-11.743,5.219 -23.148,7.841 -34.048,7.841c-4.19,-0 -8.304,-0.388 -12.338,-1.164c-15.286,-2.939 -29.476,-10.08 -42.181,-21.224c-9.443,-8.281 -17.971,-18.626 -26.066,-31.63c-0.767,-1.235 -1.524,-2.479 -2.267,-3.733l1.405,25.321l2.681,96.593l-264.105,-0l-1.3,-93.763l-11.7,93.763l-83.086,-0c0.591,-8.986 1.224,-18.148 1.9,-27.465c7.391,-101.628 19.472,-205.896 39.686,-240.01c19.819,-33.452 80.4,-42.807 113.947,-45.419c13.748,-1.07 22.953,-1.008 22.953,-1.008c0.243,0.213 0.486,0.421 0.728,0.625l0.005,-0c0.738,0.629 1.476,1.239 2.21,1.831c14.795,11.901 28.814,16.231 40.976,16.671c0.052,0 0.105,0.005 0.157,0.005c1.438,0.052 2.852,0.043 4.233,-0.014c0.143,-0.005 0.281,-0.01 0.419,-0.019c19.881,-0.918 33.924,-11.717 36.772,-14.088c0.133,-0.109 0.247,-0.199 0.328,-0.274c0.139,-0.114 0.21,-0.18 0.21,-0.18c-0,-0 9.633,-0.724 24.029,1.136c10.961,1.415 24.69,4.33 39.019,10.207c17.942,4.027 33.666,13.179 45.652,26.831c12.329,14.045 20.462,34.493 29.871,58.163c7.062,17.764 15.067,37.89 24.148,52.475c5.9,9.478 10.224,13.439 12.614,15.072c7.105,-3.18 29.981,-16.52 74.724,-68.948c30.624,-35.884 54.881,-70.622 55.119,-70.972l6.395,4.4l56.143,38.61l4.062,2.792Z",
    style: {
      fill: "#7fa2d4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.131,359.273l-24.859,4.365l47.932,47.633l20.062,-28.406l-43.135,-23.592Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.645,382.863l39.178,-18.959l23.029,4.619l-20.895,42.748l-41.312,-28.408Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.365,400.278l-24.531,-17.607l-4.264,0l-14.835,20.05l9.832,15.267l26.424,-0l7.374,-17.71Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.857,677.643l-64.286,-0l-0.004,-259.658l26.423,0l37.867,259.658Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.714,61.045c-90.995,-0 -164.762,51.271 -164.762,114.517c0,33.52 20.724,63.674 53.748,84.617c-6.557,15.169 -19.438,30.632 -44.7,29.901c-0,0 49.99,12.153 94.529,-8.162c18.919,5.263 39.566,8.162 61.185,8.162c90.996,0 164.762,-51.271 164.762,-114.518c0,-63.246 -73.766,-114.517 -164.762,-114.517Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.429,178.402c-0,8.625 -7.034,15.616 -15.715,15.616c-8.681,-0 -15.714,-6.991 -15.714,-15.616c-0,-8.625 7.033,-15.616 15.714,-15.616c8.681,-0 15.715,6.991 15.715,15.616Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.752,178.402c0,8.625 -7.033,15.616 -15.714,15.616c-8.676,-0 -15.714,-6.991 -15.714,-15.616c-0,-8.625 7.038,-15.616 15.714,-15.616c8.681,-0 15.714,6.991 15.714,15.616Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.105,178.402c-0,8.625 -7.038,15.616 -15.715,15.616c-8.68,-0 -15.714,-6.991 -15.714,-15.616c0,-8.625 7.034,-15.616 15.714,-15.616c8.677,-0 15.715,6.991 15.715,15.616Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.47,602.449l-212.428,0c-7.934,0 -14.362,-6.388 -14.362,-14.267l-0,-150.822l241.148,-0l-0,150.822c-0,7.879 -6.429,14.267 -14.358,14.267Zm-188.99,-32.827c-1.319,0 -2.391,1.065 -2.391,2.376l0,8.092c0,1.311 1.072,2.375 2.391,2.375l161.724,0c1.319,0 2.39,-1.064 2.39,-2.375l0,-8.092c0,-1.311 -1.071,-2.376 -2.39,-2.376l-161.724,0Zm-0,-23.788c-1.319,-0 -2.391,1.064 -2.391,2.375l0,8.092c0,1.311 1.072,2.376 2.391,2.376l161.724,-0c1.319,-0 2.39,-1.065 2.39,-2.376l0,-8.092c0,-1.311 -1.071,-2.375 -2.39,-2.375l-161.724,-0Zm-2.391,-96.105l0,80.881l166.505,0l0,-80.881l-166.505,0Z",
    style: {
      fill: "#fff5e2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.2,558.677l-161.724,-0c-1.319,-0 -2.391,-1.065 -2.391,-2.376l0,-8.092c0,-1.311 1.072,-2.375 2.391,-2.375l161.724,-0c1.319,-0 2.39,1.064 2.39,2.375l0,8.092c0,1.311 -1.071,2.376 -2.39,2.376Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.2,582.465l-161.724,0c-1.319,0 -2.391,-1.064 -2.391,-2.375l0,-8.092c0,-1.311 1.072,-2.376 2.391,-2.376l161.724,0c1.319,0 2.39,1.065 2.39,2.376l0,8.092c0,1.311 -1.071,2.375 -2.39,2.375Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.6,530.61l-166.505,0l0,-80.881l166.505,0l0,80.881Zm-112.919,-40.44l-12.9,26.566c3.9,1.878 8.276,2.929 12.9,2.929c8.41,-0 15.995,-3.483 21.395,-9.072c5.119,-5.304 8.272,-12.497 8.272,-20.423c-0,-2.641 -0.353,-5.192 -1.005,-7.629l-28.662,7.629Zm0,-29.498c-16.381,0 -29.662,13.205 -29.662,29.498c0,11.693 6.843,21.796 16.762,26.566l12.9,-26.566l28.662,-7.629c-3.381,-12.591 -14.929,-21.869 -28.662,-21.869Zm71.31,13.796c-5.862,0 -11.615,2.811 -15.119,8.017c-5.591,8.295 -3.362,19.524 4.981,25.08c3.109,2.073 6.623,3.062 10.104,3.062c5.862,-0 11.615,-2.811 15.119,-8.017c2.858,-4.235 3.667,-9.232 2.672,-13.855l-17.772,3.795l17.772,-3.795c-0.733,-3.403 -2.453,-6.597 -5.062,-9.129c-0.786,-0.762 -1.648,-1.467 -2.591,-2.096c-2.861,-1.907 -6.076,-2.901 -9.285,-3.043l-0.834,18.063l0.834,-18.063c-0.272,-0.014 -0.548,-0.019 -0.819,-0.019Z",
    style: {
      fill: "#ededdf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.78,516.736c-9.919,-4.77 -16.762,-14.873 -16.762,-26.566c0,-16.293 13.281,-29.498 29.662,-29.498c13.733,0 25.281,9.278 28.662,21.869l-28.662,7.629l-12.9,26.566Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.68,519.665c-4.624,-0 -9,-1.051 -12.9,-2.929l12.9,-26.566l21.395,20.423c-5.4,5.589 -12.985,9.072 -21.395,9.072Z",
    style: {
      fill: "#5f799b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.07,510.593l-21.395,-20.423l28.662,-7.629c0.652,2.437 1.005,4.988 1.005,7.629c-0,7.926 -3.153,15.119 -8.272,20.423Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.97,492.55l12.71,-12.924c2.609,2.532 4.329,5.726 5.062,9.129l-17.772,3.795Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.95,510.627c-3.481,-0 -6.995,-0.989 -10.104,-3.062c-8.343,-5.556 -10.572,-16.785 -4.981,-25.08c3.504,-5.206 9.257,-8.017 15.119,-8.017c0.271,0 0.547,0.005 0.819,0.019l-0.834,18.063l17.772,-3.795c0.995,4.623 0.186,9.62 -2.672,13.855c-3.504,5.206 -9.257,8.017 -15.119,8.017Z",
    style: {
      fill: "#81a8af",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.97,492.55l0.834,-18.063c3.209,0.142 6.424,1.136 9.285,3.043c0.943,0.629 1.805,1.334 2.591,2.096l-12.71,12.924Z",
    style: {
      fill: "#cadbd7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.83,437.36l-241.148,-0l-0,-23.317c-0,-7.88 6.428,-14.268 14.362,-14.268l212.428,-0c7.929,-0 14.358,6.388 14.358,14.268l-0,23.317Zm-176.591,-27.556c-2.628,-0 -4.762,2.118 -4.762,4.732l0,8.518c0,2.613 2.134,4.732 4.762,4.732l8.572,-0c2.628,-0 4.761,-2.119 4.761,-4.732l0,-8.518c0,-2.614 -2.133,-4.732 -4.761,-4.732l-8.572,-0Zm-23.809,-0c-2.629,-0 -4.762,2.118 -4.762,4.732l-0,8.518c-0,2.613 2.133,4.732 4.762,4.732l8.571,-0c2.629,-0 4.762,-2.119 4.762,-4.732l-0,-8.518c-0,-2.614 -2.133,-4.732 -4.762,-4.732l-8.571,-0Zm-23.81,-0c-2.629,-0 -4.762,2.118 -4.762,4.732l0,8.518c0,2.613 2.133,4.732 4.762,4.732l8.571,-0c2.629,-0 4.762,-2.119 4.762,-4.732l0,-8.518c0,-2.614 -2.133,-4.732 -4.762,-4.732l-8.571,-0Z",
    style: {
      fill: "#cadbd7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.81,427.786l-8.572,-0c-2.628,-0 -4.762,-2.119 -4.762,-4.732l0,-8.518c0,-2.614 2.134,-4.732 4.762,-4.732l8.572,-0c2.628,-0 4.761,2.118 4.761,4.732l0,8.518c0,2.613 -2.133,4.732 -4.761,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070,427.786l-8.571,-0c-2.629,-0 -4.762,-2.119 -4.762,-4.732l-0,-8.518c-0,-2.614 2.133,-4.732 4.762,-4.732l8.571,-0c2.629,-0 4.762,2.118 4.762,4.732l-0,8.518c-0,2.613 -2.133,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.19,427.786l-8.571,-0c-2.629,-0 -4.762,-2.119 -4.762,-4.732l0,-8.518c0,-2.614 2.133,-4.732 4.762,-4.732l8.571,-0c2.629,-0 4.762,2.118 4.762,4.732l0,8.518c0,2.613 -2.133,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.47,894.375l-212.566,-0c-7.934,-0 -14.362,-6.388 -14.362,-14.272l-0,-150.818l241.29,-0l0,150.818c0,7.884 -6.428,14.272 -14.362,14.272Zm-209.209,-148.67l-0,132.249l205.852,0l0,-132.249l-205.852,0Zm203.947,130.357l-202.042,-0l-0,-128.464l202.042,0l0,128.464Zm-14.252,-0.005c-1.047,-12.89 -2.671,-25.345 -5.243,-29.68c-1.343,-2.272 -4.104,-3.686 -7.143,-4.557c-0.381,-0.114 -0.766,-0.213 -1.152,-0.308c2.062,-27.919 -1.329,-33.267 -1.329,-33.267c-1.461,-4.486 -5.18,-4.912 -6.542,-4.912c-0.319,0 -0.505,0.024 -0.505,0.024c-3.286,-3.166 -6.581,-4.335 -9.6,-4.335c-5.262,0 -9.7,3.549 -11.8,6.308c-5.986,7.846 -4.029,22.539 -1.705,32.491l-0.005,0c-10.471,-1.997 -15.266,1.406 -21.676,-4.491c-0.319,-0.298 -1.571,-2.11 -3.657,-8.418l8.005,-0c4.495,-0 8.138,-3.62 8.138,-8.087l-0,-49.48c-0,-4.467 -3.643,-8.087 -8.138,-8.087l-98.624,0c-4.495,0 -8.138,3.62 -8.138,8.087l-0,49.48c-0,4.467 3.643,8.087 8.138,8.087l77.752,-0c3.205,10.69 5.519,14.324 6.996,16.132c3.652,4.453 14.761,9.739 23.514,10.292c4.843,0.312 3.238,7.136 3.162,9.252c-0.167,4.675 -0.495,10.103 -0.81,15.469l37.71,-0l-0,-5.475l0.686,5.475l11.966,-0Z",
    style: {
      fill: "#fff5e2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.11,877.954l-205.852,0l-0,-132.249l205.852,0l0,132.249Zm-203.947,-130.356l-0,128.464l202.042,-0l0,-128.464l-202.042,0Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.61,824.912l-8.005,-0c-0.462,-1.401 -0.967,-3.029 -1.514,-4.907c-1.676,-5.774 -1.686,-5.807 -1.7,-5.854l-3.119,0.573l0.143,-9.413c0.009,-0.605 -0.105,-1.211 -0.339,-1.774l-5.519,-13.335c-0.785,-0.36 -1.371,-0.493 -1.809,-0.493c-1.362,0 -1.291,1.311 -1.291,1.311l2.919,10.851l-3.452,4.529c-1.157,1.519 -1.224,3.601 -0.162,5.191l2.905,4.344l-0.005,-0l-2.366,0.435c0.047,0.228 0.204,0.876 1.99,7.018c0.152,0.525 0.3,1.032 0.452,1.524l-77.752,-0c-4.495,-0 -8.138,-3.62 -8.138,-8.087l-0,-49.48c-0,-4.467 3.643,-8.087 8.138,-8.087l98.624,0c4.495,0 8.138,3.62 8.138,8.087l-0,49.48c-0,4.467 -3.643,8.087 -8.138,8.087Zm-88.091,-34.228l0,9.465l56.015,-0l-0,-9.465l-56.015,0Zm0,-19.028l0,9.465l31.595,-0l0,-9.465l-31.595,0Z",
    style: {
      fill: "#ededdf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1077.51,
    y: 771.656,
    width: 31.595,
    height: 9.464,
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1077.51,
    y: 790.684,
    width: 56.014,
    height: 9.464,
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.42,841.512c-4.048,-0.984 -8.319,-1.112 -10.271,-1.112c-0.577,0 -0.948,0.01 -1.053,0.014l-0.028,0c-0.31,0.313 -0.629,0.592 -0.958,0.829l-0.004,-0l-0.957,-7.638c0.566,-0.36 1.138,-0.79 1.671,-1.306l-0.214,2.697c-0,0 15.328,-10.307 8.719,-26.77c-0,0 -9.319,-4.916 -18.038,-4.916c-2.576,-0 -5.096,0.426 -7.31,1.538c0,-0 -4.309,5.295 -4.962,13.571c0,0 0.262,0.052 0.734,0.119c-0.377,4.268 -0.338,10.406 2.361,13.647c1.858,2.229 4.529,3.114 7.001,3.393l-0.362,4.609c-2.558,-0.979 -5.267,-1.798 -5.267,-1.798c-0.257,-0.066 -0.51,-0.128 -0.767,-0.189c-0.609,-0.142 -1.204,-0.27 -1.776,-0.379c-2.324,-9.952 -4.281,-24.645 1.705,-32.491c2.1,-2.759 6.538,-6.308 11.8,-6.308c3.019,0 6.314,1.169 9.6,4.335c-0,-0 0.186,-0.024 0.505,-0.024c1.362,0 5.081,0.426 6.542,4.912c0,0 3.391,5.348 1.329,33.267Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.99,842.525c-3.128,-0 -5.928,-1.746 -6.3,-1.964l-0.038,-0.019c-0.295,-0.118 -0.595,-0.241 -0.904,-0.355l0.362,-4.609c0.685,0.081 1.352,0.109 1.98,0.109c2.52,-0 4.453,-0.487 4.453,-0.487c-0,-0 1.757,-0.407 3.605,-1.595l0.957,7.638c-1.315,0.946 -2.748,1.282 -4.115,1.282Z",
    style: {
      fill: "#fed1a5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.09,835.687c-0.628,-0 -1.295,-0.028 -1.98,-0.109c-2.472,-0.279 -5.143,-1.164 -7.001,-3.393c-2.699,-3.241 -2.738,-9.379 -2.361,-13.647c0.852,0.118 2.4,0.288 4.357,0.288c4.528,0 11.243,-0.903 16.547,-5.408c0,-0 3.239,1.552 1.791,6.175l-0.762,1.893c0.428,-0.54 1.233,-1.037 2.019,-1.037c0.71,0 1.414,0.403 1.824,1.557c1.324,3.715 -2.486,4.027 -3.791,4.027c-0.257,0 -0.419,-0.014 -0.419,-0.014l-0.043,0.549l-0.104,1.33l-0.348,4.401c-0.533,0.516 -1.105,0.946 -1.671,1.306c-1.848,1.188 -3.605,1.595 -3.605,1.595c-0,-0 -1.933,0.487 -4.453,0.487Z",
    style: {
      fill: "#fed1a5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.61,834.996l0.214,-2.697l0.348,-4.401l0.104,-1.33l0.043,-0.549c0,0 0.162,0.014 0.419,0.014c1.305,0 5.115,-0.312 3.791,-4.027c-0.41,-1.154 -1.114,-1.557 -1.824,-1.557c-0.786,0 -1.591,0.497 -2.019,1.037l0.762,-1.893c1.448,-4.623 -1.791,-6.175 -1.791,-6.175c-5.304,4.505 -12.019,5.408 -16.547,5.408c-1.957,0 -3.505,-0.17 -4.357,-0.288c-0.472,-0.067 -0.734,-0.119 -0.734,-0.119c0.653,-8.276 4.962,-13.571 4.962,-13.571c2.214,-1.112 4.734,-1.538 7.31,-1.538c8.719,-0 18.038,4.916 18.038,4.916c6.609,16.463 -8.719,26.77 -8.719,26.77Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.66,815.935l-2.905,-4.344c-1.062,-1.59 -0.995,-3.672 0.162,-5.191l3.452,-4.529l-2.919,-10.851c0,0 -0.071,-1.311 1.291,-1.311c0.438,0 1.024,0.133 1.809,0.493l5.519,13.335c0.234,0.563 0.348,1.169 0.339,1.774l-0.143,9.413l-6.605,1.211Z",
    style: {
      fill: "#fed1a5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.96,876.057l-11.966,-0l-0.686,-5.475l-0,5.475l-37.71,-0c0.315,-5.366 0.643,-10.794 0.81,-15.469c0.076,-2.116 1.681,-8.94 -3.162,-9.252c-8.753,-0.553 -19.862,-5.839 -23.514,-10.292c-1.477,-1.808 -3.791,-5.442 -6.996,-16.132c-0.152,-0.492 -0.3,-0.999 -0.452,-1.524c-1.786,-6.142 -1.943,-6.79 -1.99,-7.018l2.366,-0.435l0.005,-0l6.605,-1.211l3.119,-0.573c0.014,0.047 0.024,0.08 1.7,5.854c0.547,1.878 1.052,3.506 1.514,4.907c2.086,6.308 3.338,8.12 3.657,8.418c6.41,5.897 11.205,2.494 21.676,4.491l0.005,0c0.572,0.109 1.167,0.237 1.776,0.379c0.257,0.061 0.51,0.123 0.767,0.189c-0,0 2.709,0.819 5.267,1.798c0.309,0.114 0.609,0.237 0.904,0.355l0.038,0.019c0.372,0.218 3.172,1.964 6.3,1.964c1.367,-0 2.8,-0.336 4.115,-1.282l0.004,-0c0.329,-0.237 0.648,-0.516 0.958,-0.829l0.028,0c0.105,-0.004 0.476,-0.014 1.053,-0.014c1.952,0 6.223,0.128 10.271,1.112c0.386,0.095 0.771,0.194 1.152,0.308c3.039,0.871 5.8,2.285 7.143,4.557c2.572,4.335 4.196,16.79 5.243,29.68Z",
    style: {
      fill: "#a5c4c7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.83,729.285l-241.29,-0l-0,-23.311c-0,-7.884 6.428,-14.272 14.362,-14.272l212.566,0c7.934,0 14.362,6.388 14.362,14.272l0,23.311Zm-177.071,-27.508c-2.629,-0 -4.762,2.12 -4.762,4.732l-0,8.518c-0,2.612 2.133,4.732 4.762,4.732l8.571,-0c2.629,-0 4.762,-2.12 4.762,-4.732l0,-8.518c0,-2.612 -2.133,-4.732 -4.762,-4.732l-8.571,-0Zm-23.81,-0c-2.628,-0 -4.762,2.12 -4.762,4.732l0,8.518c0,2.612 2.134,4.732 4.762,4.732l8.572,-0c2.628,-0 4.762,-2.12 4.762,-4.732l-0,-8.518c-0,-2.612 -2.134,-4.732 -4.762,-4.732l-8.572,-0Zm-23.809,-0c-2.629,-0 -4.762,2.12 -4.762,4.732l-0,8.518c-0,2.612 2.133,4.732 4.762,4.732l8.571,-0c2.629,-0 4.762,-2.12 4.762,-4.732l0,-8.518c0,-2.612 -2.133,-4.732 -4.762,-4.732l-8.571,-0Z",
    style: {
      fill: "#cadbd7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.33,719.759l-8.571,-0c-2.629,-0 -4.762,-2.12 -4.762,-4.732l-0,-8.518c-0,-2.612 2.133,-4.732 4.762,-4.732l8.571,-0c2.629,-0 4.762,2.12 4.762,4.732l0,8.518c0,2.612 -2.133,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.52,719.759l-8.572,-0c-2.628,-0 -4.762,-2.12 -4.762,-4.732l0,-8.518c0,-2.612 2.134,-4.732 4.762,-4.732l8.572,-0c2.628,-0 4.762,2.12 4.762,4.732l-0,8.518c-0,2.612 -2.134,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.71,719.759l-8.571,-0c-2.629,-0 -4.762,-2.12 -4.762,-4.732l-0,-8.518c-0,-2.612 2.133,-4.732 4.762,-4.732l8.571,-0c2.629,-0 4.762,2.12 4.762,4.732l0,8.518c0,2.612 -2.133,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.57,310.567l-212.566,-0c-7.934,-0 -14.362,-6.39 -14.362,-14.273l-0,-150.816l241.29,-0l0,150.816c0,7.883 -6.428,14.273 -14.362,14.273Zm-177.138,-33.779c-1.057,-0 -1.914,0.852 -1.914,1.903l0,8.563c0,1.052 0.857,1.904 1.914,1.904l170.438,-0c1.058,-0 1.915,-0.852 1.915,-1.904l-0,-8.563c-0,-1.051 -0.857,-1.903 -1.915,-1.903l-170.438,-0Zm-28.724,-0c-1.057,-0 -1.914,0.852 -1.914,1.903l0,8.563c0,1.052 0.857,1.904 1.914,1.904l12.448,-0c1.057,-0 1.914,-0.852 1.914,-1.904l0,-8.563c0,-1.051 -0.857,-1.903 -1.914,-1.903l-12.448,-0Zm28.724,-28.546c-1.057,0 -1.914,0.852 -1.914,1.903l0,8.564c0,1.051 0.857,1.903 1.914,1.903l108.2,-0c1.057,-0 1.915,-0.852 1.915,-1.903l-0,-8.564c-0,-1.051 -0.858,-1.903 -1.915,-1.903l-108.2,0Zm-28.724,0c-1.057,0 -1.914,0.852 -1.914,1.903l0,8.564c0,1.051 0.857,1.903 1.914,1.903l12.448,-0c1.057,-0 1.914,-0.852 1.914,-1.903l0,-8.564c0,-1.051 -0.857,-1.903 -1.914,-1.903l-12.448,0Zm28.724,-28.545c-1.057,-0 -1.914,0.852 -1.914,1.903l0,8.563c0,1.051 0.857,1.903 1.914,1.903l92.4,0c1.057,0 1.915,-0.852 1.915,-1.903l-0,-8.563c-0,-1.051 -0.858,-1.903 -1.915,-1.903l-92.4,-0Zm-28.724,-0c-1.057,-0 -1.914,0.852 -1.914,1.903l0,8.563c0,1.051 0.857,1.903 1.914,1.903l12.448,0c1.057,0 1.914,-0.852 1.914,-1.903l0,-8.563c0,-1.051 -0.857,-1.903 -1.914,-1.903l-12.448,-0Zm146.496,-57.092l-0,60.422l60.805,-0l-0,-60.422l-60.805,0Zm-117.772,28.546c-1.057,-0 -1.914,0.852 -1.914,1.903l0,8.564c0,1.051 0.857,1.903 1.914,1.903l69.9,-0c1.057,-0 1.915,-0.852 1.915,-1.903l-0,-8.564c-0,-1.051 -0.858,-1.903 -1.915,-1.903l-69.9,-0Zm-28.724,-0c-1.057,-0 -1.914,0.852 -1.914,1.903l0,8.564c0,1.051 0.857,1.903 1.914,1.903l12.448,-0c1.057,-0 1.914,-0.852 1.914,-1.903l0,-8.564c0,-1.051 -0.857,-1.903 -1.914,-1.903l-12.448,-0Zm28.724,-28.546c-1.057,0 -1.914,0.852 -1.914,1.903l0,8.564c0,1.051 0.857,1.903 1.914,1.903l54.577,0c1.057,0 1.919,-0.852 1.919,-1.903l-0,-8.564c-0,-1.051 -0.862,-1.903 -1.919,-1.903l-54.577,0Zm-28.724,0c-1.057,0 -1.914,0.852 -1.914,1.903l0,8.564c0,1.051 0.857,1.903 1.914,1.903l12.448,0c1.057,0 1.914,-0.852 1.914,-1.903l0,-8.564c0,-1.051 -0.857,-1.903 -1.914,-1.903l-12.448,0Z",
    style: {
      fill: "#fff5e2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.01,223.027l-60.805,-0l-0,-60.422l60.805,0l-0,60.422Zm-30.162,-21.885c-8.991,-0 -16.277,7.242 -16.277,16.176l32.553,-0c-0,-8.934 -7.286,-16.176 -16.276,-16.176Zm-0.481,-22.837c-6.343,0 -11.491,5.112 -11.491,11.419c0,6.305 5.148,11.418 11.491,11.418c6.347,-0 11.49,-5.113 11.49,-11.418c0,-6.307 -5.143,-11.419 -11.49,-11.419Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.37,201.142c-6.343,-0 -11.491,-5.113 -11.491,-11.418c0,-6.307 5.148,-11.419 11.491,-11.419c6.347,0 11.49,5.112 11.49,11.419c0,6.305 -5.143,11.418 -11.49,11.418Z",
    style: {
      fill: "#ededdf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.12,217.318l-32.553,-0c0,-8.934 7.286,-16.176 16.277,-16.176c8.99,-0 16.276,7.242 16.276,16.176Z",
    style: {
      fill: "#ededdf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.16,174.975l-12.448,0c-1.057,0 -1.914,-0.852 -1.914,-1.903l0,-8.564c0,-1.051 0.857,-1.903 1.914,-1.903l12.448,0c1.057,0 1.914,0.852 1.914,1.903l0,8.564c0,1.051 -0.857,1.903 -1.914,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.01,174.975l-54.577,0c-1.057,0 -1.914,-0.852 -1.914,-1.903l0,-8.564c0,-1.051 0.857,-1.903 1.914,-1.903l54.577,0c1.057,0 1.919,0.852 1.919,1.903l-0,8.564c-0,1.051 -0.862,1.903 -1.919,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.16,203.521l-12.448,-0c-1.057,-0 -1.914,-0.852 -1.914,-1.903l0,-8.564c0,-1.051 0.857,-1.903 1.914,-1.903l12.448,-0c1.057,-0 1.914,0.852 1.914,1.903l0,8.564c0,1.051 -0.857,1.903 -1.914,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.33,203.521l-69.9,-0c-1.057,-0 -1.914,-0.852 -1.914,-1.903l0,-8.564c0,-1.051 0.857,-1.903 1.914,-1.903l69.9,-0c1.057,-0 1.915,0.852 1.915,1.903l-0,8.564c-0,1.051 -0.858,1.903 -1.915,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.16,232.066l-12.448,0c-1.057,0 -1.914,-0.852 -1.914,-1.903l0,-8.563c0,-1.051 0.857,-1.903 1.914,-1.903l12.448,-0c1.057,-0 1.914,0.852 1.914,1.903l0,8.563c0,1.051 -0.857,1.903 -1.914,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.83,232.066l-92.4,0c-1.057,0 -1.914,-0.852 -1.914,-1.903l0,-8.563c0,-1.051 0.857,-1.903 1.914,-1.903l92.4,-0c1.057,-0 1.915,0.852 1.915,1.903l-0,8.563c-0,1.051 -0.858,1.903 -1.915,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.63,260.612l-108.2,-0c-1.057,-0 -1.914,-0.852 -1.914,-1.903l0,-8.564c0,-1.051 0.857,-1.903 1.914,-1.903l108.2,0c1.057,0 1.915,0.852 1.915,1.903l-0,8.564c-0,1.051 -0.858,1.903 -1.915,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.87,289.158l-170.438,-0c-1.057,-0 -1.914,-0.852 -1.914,-1.904l0,-8.563c0,-1.051 0.857,-1.903 1.914,-1.903l170.438,-0c1.058,-0 1.915,0.852 1.915,1.903l-0,8.563c-0,1.052 -0.857,1.904 -1.915,1.904Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.16,260.612l-12.448,-0c-1.057,-0 -1.914,-0.852 -1.914,-1.903l0,-8.564c0,-1.051 0.857,-1.903 1.914,-1.903l12.448,0c1.057,0 1.914,0.852 1.914,1.903l0,8.564c0,1.051 -0.857,1.903 -1.914,1.903Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.16,289.158l-12.448,-0c-1.057,-0 -1.914,-0.852 -1.914,-1.904l0,-8.563c0,-1.051 0.857,-1.903 1.914,-1.903l12.448,-0c1.057,-0 1.914,0.852 1.914,1.903l0,8.563c0,1.052 -0.857,1.904 -1.914,1.904Z",
    style: {
      fill: "#98a8bd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.78,145.387l-241.148,-0l0,-23.317c0,-7.881 6.429,-14.268 14.362,-14.268l212.429,-0c7.928,-0 14.357,6.387 14.357,14.268l-0,23.317Zm-176.591,-27.557c-2.628,0 -4.761,2.119 -4.761,4.732l-0,8.518c-0,2.614 2.133,4.732 4.761,4.732l8.572,0c2.628,0 4.762,-2.118 4.762,-4.732l-0,-8.518c-0,-2.613 -2.134,-4.732 -4.762,-4.732l-8.572,0Zm-23.809,0c-2.629,0 -4.762,2.119 -4.762,4.732l0,8.518c0,2.614 2.133,4.732 4.762,4.732l8.571,0c2.629,0 4.762,-2.118 4.762,-4.732l0,-8.518c0,-2.613 -2.133,-4.732 -4.762,-4.732l-8.571,0Zm-23.81,0c-2.628,0 -4.761,2.119 -4.761,4.732l-0,8.518c-0,2.614 2.133,4.732 4.761,4.732l8.572,0c2.628,0 4.762,-2.118 4.762,-4.732l-0,-8.518c-0,-2.613 -2.134,-4.732 -4.762,-4.732l-8.572,0Z",
    style: {
      fill: "#cadbd7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.76,135.812l-8.572,0c-2.628,0 -4.761,-2.118 -4.761,-4.732l-0,-8.518c-0,-2.613 2.133,-4.732 4.761,-4.732l8.572,0c2.628,0 4.762,2.119 4.762,4.732l-0,8.518c-0,2.614 -2.134,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.95,135.812l-8.571,0c-2.629,0 -4.762,-2.118 -4.762,-4.732l0,-8.518c0,-2.613 2.133,-4.732 4.762,-4.732l8.571,0c2.629,0 4.762,2.119 4.762,4.732l0,8.518c0,2.614 -2.133,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.14,135.812l-8.572,0c-2.628,0 -4.761,-2.118 -4.761,-4.732l-0,-8.518c-0,-2.613 2.133,-4.732 4.761,-4.732l8.572,0c2.628,0 4.762,2.119 4.762,4.732l-0,8.518c-0,2.614 -2.134,4.732 -4.762,4.732Z",
    style: {
      fill: "#768cab",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning02);
export default __webpack_public_path__ + "static/media/learning-02.e7e8795fdcc56558d0cf81d4e90907b3.svg";
export { ForwardRef as ReactComponent };